<section class="add-property-details" id="add-property-details-step">
	<header class="row page-header">
        <p>Enter the details of the property you want to add.</p>
	</header>
	<main>
        <form [formGroup]="formGroup">
			<div class="form-section">
                <h2 class="section-header">GENERAL INFO</h2>
                <div class="row" *ngIf="workspaces?.length > 0">
                    <div class="col-lg-2 col-md-3 col-sm-12">
                        <label>Workspace</label>&nbsp;<span class="red">*</span>
                    </div>
                    <!-- If Modal is launched in the "Admin > Portfolios" area -->
                    <div class="col-md-8 col-sm-12" *ngIf="currentWorkspaceId">                        
                        <select class="sp-select form-control" [disabled]="true">
                            <option *ngFor="let workspace of sortedWorkspaces" 
                                [value]="currentWorkspaceId" 
                                [selected]="currentWorkspaceId === workspace.workspaceId">
                                {{ workspace.companyName || workspace.name }}
                            </option>
                        </select>
                    </div>
                    <!-- If Modal is launched in the "Properties" area -->
                    <div class="col-md-8 col-sm-12" *ngIf="!currentWorkspaceId">
                        <select class="sp-select form-control" formControlName="workspaceId" name="workspaceId">
                            <option [value]="workspace?.workspaceId" *ngFor="let workspace of sortedWorkspaces">{{ workspace.companyName || workspace.name }}</option>
                        </select>
                        <sp-field-error [controlName]="'Workspace'" [control]="formGroup.controls['workspaceId']"></sp-field-error>
                    </div>
                </div>

                <div class="row top-buffer-20" *spIsSpUser="userProfile?.email">
                    <div class="col-md-12">
                        <label id="isTest" for="isTest">Is this a Test property?</label>
                        &nbsp;
                        <label class="btn-radio-container">
                            <input type="radio" formControlName="isTest" [value]="false"><span></span> No
                        </label>
                        <label class="btn-radio-container">
                            <input type="radio" formControlName="isTest" [value]="true"><span></span> Yes
                        </label>
                    </div>
                </div>

                <div class="row" [class.top-buffer-20]="workspaces?.length > 0">
                    <div class="col-lg-2 col-md-3 col-sm-12">
                        <label>Property Name</label>&nbsp;<span class="red">*</span>
                    </div>
                    <div class="col-md-8 col-sm-12">
                        <input type="text" class="form-control" name="name" placeholder="Property Name" maxlength="250"
                               formControlName="name" />
                        <sp-field-error [controlName]="'Property Name'" [control]="formGroup.controls['name']"></sp-field-error>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-2 col-md-3 col-sm-12 top-buffer-20">
                        <label>Property Address </label>&nbsp;<span class="red">*</span>
                    </div>
                    <div class="col-md-8 col-sm-12">
                        <div class="row top-buffer-20">
                            <div class="col-md-12">
                                <input type="text" class="form-control" formControlName="address1" name="address1" placeholder="Property Address"
                                       maxlength="100">
                                <sp-field-error [controlName]="'Property Address'" [control]="formGroup.controls['address1']"></sp-field-error>
                            </div>
                        </div>
                        <div class="row top-buffer-20">
                            <div class="col-md-12">
                                <input type="text" class="form-control" formControlName="address2" name="address2"
                                 maxlength="100" placeholder="Property Address Line 2" />
                                <sp-field-error [controlName]="'Property Address Line 2'" [control]="formGroup.controls['address2']"></sp-field-error>
                            </div>
                        </div>
                        <div class="row top-buffer-20">
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <input type="text" class="form-control" formControlName="city" name="city" placeholder="City" #city maxlength="100">
                                <sp-field-error [controlName]="'City'" [control]="formGroup.controls['city']"></sp-field-error>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-6 clear-padding extendable">
                                <select class="sp-select form-control" formControlName="state" name="state" #state>
                                    <option *ngFor="let state of states">{{ state }}</option>
                                    </select>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-6 extendable">
                                <input type="text" class="form-control" formControlName="zipCode" name="zipCode" placeholder="Zip Code"
                                       minlength="5" maxlength="5">
                                <sp-field-error [controlName]="'Zip Code'" [control]="formGroup.controls['zipCode']"></sp-field-error>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
			<div class="form-section">
                <h2 class="section-header">PROPERTY DETAILS</h2>
                <div class="row">
                    <div class="col-lg-2 col-md-3 col-sm-12">
                        <label>Year Built</label>&nbsp;<span class="red">*</span>
                    </div>
                    <div class="col-md-8 col-sm-12" [class.ng-invalid]="yearBuilt.value < 1700 || yearBuilt.value > currentYear">
                        <input type="text" step="1" class="form-control" formControlName="yearBuilt" name="yearBuilt" #yearBuilt
                         placeholder="Year Built" maxlength="4" />
                        <sp-field-error [controlName]="'Year Built'" [control]="formGroup.controls['yearBuilt']"></sp-field-error>
                    </div>
                </div>
                <div class="row top-buffer-20">
                    <div class="col-lg-2 col-md-3 col-sm-12">
                        <label for="propertyType">Property Type</label>
                    </div>
                    <div class="col-md-8 col-sm-12">
                        <select class="sp-select form-control" formControlName="propertyTypeId" placeholder="Start Date" name="propertyType"
                         #propertyType id="propertyType">
                            <option *ngFor="let propertyType of propertyTypes" value="{{propertyType.id}}">{{ propertyType.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="row top-buffer-20">
                    <div class="col-lg-2 col-md-3 col-sm-12">
                        <label>Number of {{ 'Units' | terminology | async }}</label>&nbsp;<span class="red">*</span>
                    </div>
                    <div class="col-md-8 col-sm-12">
                        <input type="text" maxlength="5" class="form-control" formControlName="numberOfUnits" name="numberOfUnits" [placeholder]="(('Units' | terminology | async) || 'Units')" />
                        <sp-field-error [controlName]="'Number of Units'" [control]="formGroup.controls['numberOfUnits']"></sp-field-error>

                    </div>
                </div>
                <div class="row top-buffer-20">
                    <div class="col-lg-2 col-md-3 col-sm-12">
                        <label>Number of floors in the building</label>
                    </div>
                    <div class="col-md-8 col-sm-12">
                        <input type="text" maxlength="5" class="form-control" formControlName="numberOfFloors" name="numberOfFloors" placeholder="Floors" />
                        <!-- <sp-field-error [controlName]="'Number of Floors'" [control]="formGroup.controls['numberOfFloors']"></sp-field-error> -->
                    </div>
                </div>
                <div class="row top-buffer-20">
                    <div class="col-md-12">
                        <label>Was your property ever a condo conversion?</label>
                        &nbsp;
                        <label class="btn-radio-container"><input type="radio" [value]="false" #conversionNo formControlName="conversionYesNo"><span></span> No</label>
                        <label class="btn-radio-container"><input type="radio" [value]="true" #conversionYes formControlName="conversionYesNo"><span></span> Yes</label>
                    </div>
                </div>

                <ng-container *ngIf="conversionYes.checked">
                    <div class="row top-buffer-20">
                        <div class="col-lg-2 col-md-3 col-sm-12">
                            <label for="yearOfConversion">Year Converted</label>&nbsp;<span class="red">*</span>
                        </div>
                        <div class="col-md-8 col-sm-12">
                            <input type="text" maxLength="4" class="form-control" formControlName="yearOfConversion" name="yearOfConversion"
                                   id="yearOfConversion" placeholder="Year of Conversion">
                            <sp-field-error [controlName]="'Year of Conversion'" [control]="formGroup.controls['yearOfConversion']"></sp-field-error>
                        </div>
                    </div>
                </ng-container>

                <div class="row top-buffer-20">
                    <div class="col-lg-2 col-md-3 col-sm-12">
                        <label>Property Description</label>
                    </div>
                    <div class="col-md-8 col-sm-12">
                        <textarea class="form-control" formControlName="propertyDescription" name="propertyDescription"
                                  rows="5" placeholder="Description"></textarea>
                        <sp-field-error [controlName]="'Property Description'" [control]="formGroup.controls['propertyDescription']"></sp-field-error>
                    </div>
                </div>
			</div>
		</form>
	</main>
</section>
